export default "__VITE_ASSET__J_xj$tz8__"